import { render } from "./App.vue?vue&type=template&id=3223f83e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3223f83e&lang=scss"

import exportComponent from "/home/runner/work/nush-bookings/nush-bookings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__